import { GET_ORDER_HISTORY } from './actions'

const intialState = {
  total: 0,
  order_history: [],
  loading_get_order_history: false,
}

export default (state = intialState, action) => {
  switch (action.type) {
    case GET_ORDER_HISTORY.REQUEST:
      return {
        ...state,
        loading_get_order_history: true,
      }
    case GET_ORDER_HISTORY.SUCCESS:
      return {
        ...state,
        total: action.payload.lists.total,
        order_history: action.payload.lists.data,
        loading_get_order_history: false,
      }
    case GET_ORDER_HISTORY.FAILURE:
      return {
        ...state,
      }

    default:
      return state
  }
}
